'use client';

import { useCookieConsent } from '@/context/CookieConsentContext';
import { Card } from './ui/card';
import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

interface DaisyconAdProps {
  className?: string;
  html?: string; // For a single, static ad
  htmls?: string[]; // For rotating ads
}

const DaisyconAd = ({ className, html, htmls }: DaisyconAdProps) => {
  const { consent } = useCookieConsent();
  const [randomlySelectedHtml, setRandomlySelectedHtml] = useState<string | undefined>(undefined);

  useEffect(() => {
    // This effect handles the case where an array of ads is passed for rotation.
    // It runs only on the client to avoid hydration issues with Math.random().
    if (htmls && htmls.length > 0) {
      const randomIndex = Math.floor(Math.random() * htmls.length);
      setRandomlySelectedHtml(htmls[randomIndex]);
    }
  }, [htmls]); // Reruns if the htmls array itself changes.

  // Determine the final HTML to display.
  // Prioritize the direct `html` prop. If it's not provided, use the randomly selected one.
  const adHtml = html ?? randomlySelectedHtml;

  if (!consent.advertising) {
    return (
      <Card className={cn("flex flex-col items-center justify-center min-h-[100px] text-muted-foreground text-center p-4 border-dashed bg-muted/20", className)}>
        <p className="text-[10px] font-bold uppercase tracking-widest mb-2 opacity-60">Advertentie</p>
        <p className="text-xs italic">Advertenties zijn uitgeschakeld op basis van uw cookievoorkeuren.</p>
      </Card>
    );
  }

  // If no ad content is available, don't render anything.
  if (!adHtml) {
    return null;
  }

  return (
    <div className={cn("relative pt-3", className)}>
      <div className="absolute top-0 left-4 bg-background px-2 py-0.5 text-[10px] font-black text-muted-foreground uppercase tracking-widest z-10 border rounded-full shadow-sm">
        Advertentie
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: adHtml }}
      />
    </div>
  );
};

export default DaisyconAd;
